import { render, staticRenderFns } from "./SimpleMenu.vue?vue&type=template&id=6b329cda&"
import script from "./SimpleMenu.vue?vue&type=script&lang=js&"
export * from "./SimpleMenu.vue?vue&type=script&lang=js&"
import style0 from "./SimpleMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports